<template>
    <div class="mr-5 ml-5 roma-link">
        <v-row >
            <v-col >
                <v-card height="100%"  elevation="2" class="d-flex flex-column align-center">
                    <img
                    src="@/assets/images/link.jpg"
                    class="img"
                    />
                    <v-card-text >
                        <!-- <h4 class="text-center font-weight-bold">
                            RECURSO DE ENLACE EXTERNO
                        </h4> -->
                        <p class="text-center text-subtitle-1">
                            Dar clic en el botón para redireccionar:
                        </p>
                    </v-card-text>
                        <a :href="url" target="_blank" class="white--text link">
                             
                            <v-btn class="text-center btn" color="primary">
                                <v-icon class="mr-3">
                                mdi-link
                                </v-icon>
                                Link
                             </v-btn>
                        </a>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            resource: "getCurrentResource"
        }),
        url() {
            return this.resource.link;
        }
    }
};
</script>

<style lang="scss">
.roma-link {

    .row{
        height: 100%;
        .col{
            height: 100%;
        }
    }
    .link{
        text-decoration: none;
    }

    .btn{
        width: 150px;
        a{
            width: 100%;
        }
    }

    .img{
        height: 200px ;
        width: 200px;
    }

}
</style>
